import { COMPONENT_TYPE } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const content = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.CONTENT> =>
	createModel({
		type: COMPONENT_TYPE.CONTENT,
		editorProps: {
			selectable: false,
			draggable: false,
			expandable: true,
			expanded: true,
		},
		componentProps: {
			styles: {},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.CONTENT>;
